export function parseInternalRedirect(url) {
    const { $applicationConstants } = useNuxtApp()
    const { nuxtBaseUrl } = $applicationConstants

    while (url && url.startsWith(nuxtBaseUrl)) {
        url = url.slice(nuxtBaseUrl.length) || '/'
    }

    return url
}